import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "weather-ico" }
const _hoisted_2 = ["src", "width"]

import { computed } from "vue";

interface Props {
  ico: string;
  size?: number;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    ico: null,
    size: null
  },
  setup(__props: any) {

const props = __props as {
  ico: string;
  size?: number;
}



const image = computed(() => {
  return require(`@/assets/svg/${props.ico}.svg`);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _unref(image),
      width: __props.size
    }, null, 8, _hoisted_2)
  ]))
}
}

})